export default {
  hours: [],
  anomalies: [],
  formations: [],
  stats: [],
  errors: null
};
